import React from "react";
import s from "./style.module.scss";
import { useAppDispatch } from "shared/redux/hooks";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import Button from "../Button";
import { SetState } from "shared/types/general";

interface ErrorProps {
  text: string;
}

const Error: React.FC<ErrorProps> = ({ text }) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setOpen(false));
    dispatch(setContent(null));
  };

  return (
    <div className={s.error}>
      <h6 className={s.title}>Ошибка</h6>
      <p className={s.text}>{text}</p>

      <Button onClick={handleClose} className={s.button}>
        Закрыть
      </Button>
    </div>
  );
};

export default Error;
